import React, { useState } from "react";

import TopicContext from "../../../contexts/TopicContext";

import PageTitleNew from "../../ui/PageTitleNew";
import Table from "./Table";
import ModalForm from "./Form/Modal";

export default function Index() {
  return (
    <TopicContext>
      <div className="wrapper_assestment invite_wrapper">
        <PageTitleNew title="Topics" />

        <div className="ibox-content mt20">
          <Table />
        </div>
      </div>
      <ModalForm />
    </TopicContext>
  );
}
